const browseZonesList = [
  {
    zone: 'BROWSE_ZONE_B',
    recipeId: '820-21',
  },
  {
    zone: 'BROWSE_ZONE_D',
    recipeId: '823-21',
  },
  {
    zone: 'BROWSE_ZONE_E',
    recipeId: '824-21',
  },
  {
    zone: 'BROWSE_ZONE_F',
    recipeId: '829-21',
  },
  {
    zone: 'BROWSE_ZONE_G',
    recipeId: '830-21',
  },
  {
    zone: 'BROWSE_ZONE_H',
    recipeId: '1213-21',
  },
  {
    zone: 'BROWSE_ZONE_I',
    recipeId: '1214-21',
  },
  {
    zone: 'BROWSE_ZONE_J',
    recipeId: '1215-21',
  },
  {
    zone: 'BROWSE_ZONE_K',
    recipeId: '1216-21',
  },
  {
    zone: 'BROWSE_ZONE_L',
    recipeId: '1217-21',
  },
];

export const killswitchFromZoneName = (zone) => {
  if (typeof window !== 'object' || !zone || typeof zone !== 'string') {
    return undefined;
  }

  const nameToArray = zone.split('_');
  const capitalize = (name) => (name.length ? name[0].toUpperCase() + name.slice(1).toLowerCase() : '');
  const formattedNameArray = nameToArray.map((element, index) => (index === 0 ? element.toUpperCase() : capitalize(element)));

  return `pros${window.innerWidth < 1024 ? 'MEW' : 'Desktop'}${formattedNameArray.join('')}Enabled`;
};

export const isZoneInBrowseList = (zoneName) => {
  const setOfBrowseZones = new Set();
  browseZonesList.forEach((recipe) => { setOfBrowseZones.add(recipe.zone); });

  return setOfBrowseZones.has(zoneName);
};

export const useExperimentationForBrowse = async ({ zoneName, _properties = {}, expSdk }) => {
  let setKillSwitchUsingExperimentation;
  const properties = { ..._properties };

  try {
    const module2 = await import('../utils/killSwitchUtil');
    setKillSwitchUsingExperimentation = module2.setKillSwitchUsingExperimentation;
  } catch (err) {
    throw new Error('Module load failed');
  }

  const recipesForZone = browseZonesList.filter((recipe) => recipe.zone === zoneName);

  if (recipesForZone.length > 0) {
    recipesForZone.forEach((recipe) => {
      const zoneKsProp = killswitchFromZoneName(recipe.zone);

      if (properties[zoneKsProp]) {
        setKillSwitchUsingExperimentation(
          recipe.recipeId,
          zoneKsProp,
          properties,
          expSdk,
        );
      }
    });
  }

  return { properties };
};
